// extracted by mini-css-extract-plugin
export default {"mapLabels":"GeoService_mapLabels__dHUjV","mapLabelsLight":"GeoService_mapLabelsLight__EPst+"};